var map = {
	"./User/UserName.js": "./js/src/preact-components/User/UserName.js",
	"./analytics/Analytics.js": "./js/src/preact-components/analytics/Analytics.js",
	"./content-curation/ContentCurationItem.js": "./js/src/preact-components/content-curation/ContentCurationItem.js",
	"./content-curation/ContentCurationManager.js": "./js/src/preact-components/content-curation/ContentCurationManager.js",
	"./content-quote/index.js": "./js/src/preact-components/content-quote/index.js",
	"./control/InputAddon.js": "./js/src/preact-components/control/InputAddon.js",
	"./editor-wysiwyg-react/index.js": "./js/src/preact-components/editor-wysiwyg-react/index.js",
	"./editor/index.js": "./js/src/preact-components/editor/index.js",
	"./email-management/EmailManager.js": "./js/src/preact-components/email-management/EmailManager.js",
	"./grid-control/grid-control.js": "./js/src/preact-components/grid-control/grid-control.js",
	"./hover/Hover.js": "./js/src/preact-components/hover/Hover.js",
	"./menu/main.sync.js": "./js/src/preact-components/menu/main.sync.js",
	"./pagination/PageInfo.js": "./js/src/preact-components/pagination/PageInfo.js",
	"./pagination/PageSizeSelector.js": "./js/src/preact-components/pagination/PageSizeSelector.js",
	"./private-message/more-options/DeletePrivateMessage.js": "./js/src/preact-components/private-message/more-options/DeletePrivateMessage.js",
	"./seo/Robots.js": "./js/src/preact-components/seo/Robots.js",
	"./topic-helpfulness/assets/confused.js": "./js/src/preact-components/topic-helpfulness/assets/confused.js",
	"./topic-helpfulness/assets/happy.js": "./js/src/preact-components/topic-helpfulness/assets/happy.js",
	"./topic-helpfulness/assets/weary.js": "./js/src/preact-components/topic-helpfulness/assets/weary.js",
	"./topic-helpfulness/topicHelpfulness.js": "./js/src/preact-components/topic-helpfulness/topicHelpfulness.js",
	"./topic-list-view/TopicLabel.js": "./js/src/preact-components/topic-list-view/TopicLabel.js",
	"./topic-list-view/TopicListLikeButton.js": "./js/src/preact-components/topic-list-view/TopicListLikeButton.js",
	"./topic-suggestion/Link.js": "./js/src/preact-components/topic-suggestion/Link.js",
	"./topic-suggestion/SearchBox.js": "./js/src/preact-components/topic-suggestion/SearchBox.js",
	"./topic-suggestion/SuggestedTopicsList.js": "./js/src/preact-components/topic-suggestion/SuggestedTopicsList.js",
	"./topic-suggestion/SuggestedTopicsListContainer.js": "./js/src/preact-components/topic-suggestion/SuggestedTopicsListContainer.js",
	"./topic-suggestion/index.js": "./js/src/preact-components/topic-suggestion/index.js",
	"./translations/TranslationForm.js": "./js/src/preact-components/translations/TranslationForm.js",
	"./user-mention/index.js": "./js/src/preact-components/user-mention/index.js",
	"./widget-last-visitors/LastVisitors.sync.js": "./js/src/preact-components/widget-last-visitors/LastVisitors.sync.js",
	"./widget-notification/featuredBanner/index.js": "./js/src/preact-components/widget-notification/featuredBanner/index.js"
};


function webpackAsyncContext(req) {
	return webpackAsyncContextResolve(req).then(__webpack_require__);
}
function webpackAsyncContextResolve(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncaught exception popping up in devtools
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}
		return map[req];
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.resolve = webpackAsyncContextResolve;
webpackAsyncContext.id = "./js/src/preact-components eager recursive ^\\.\\/.*\\.js$ exclude: (server%7C\\.(spec%7Ctest)\\.tsx?$%7Csettings%7Ctheme-configuration%7Cadmin-toolbar%7C\\.lazy)";
module.exports = webpackAsyncContext;